module.exports = __webpack_public_path__ + "static/media/0007.3408e47b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/handles/H48011/Chassis_RAL/0007.png
// module id = 469
// module chunks = 0